// extracted by mini-css-extract-plugin
module.exports = {"divider":"CityPage_divider__c7cRL"};